<template>
  <div class="relative clearfix">
    <div class="float-left mt-4 flex flex-wrap w-full items-center md:gap-4 gap-2">
      <div @click="filterDropdownFlag = false, warehouseDropdownFlag = false" v-if="filterDropdownFlag || warehouseDropdownFlag" class="fixed inset-0 bg-transparent filter-z-index"></div>
      <div class="relative md:w-48 w-full" :class="filterDropdownFlag ? 'filter-z-index' : ''">
        <div @click="filterDropdownFlag = !filterDropdownFlag" class="flex gap-4 cursor-pointer bg-white items-center border border-solid border-grey-light p-2 rounded-lg whitespace-nowrap overflow-hidden">
          <span class="material-icons-outlined text-lg">equalizer</span>
          <p class="truncate w-full capitalize font-medium text-sm">{{filters.length === 0 ? $t('Status') : filters.map(item => $t(item.replaceAll('_', ' '))).join(', ')}}</p>
          <div class="text-right flex items-center">
            <feather-icon class="w-4 h-4" :icon="filterDropdownFlag ? 'ChevronUpIcon' : 'ChevronDownIcon'"></feather-icon>
          </div>
        </div>
        <div v-if="filterDropdownFlag" class="absolute w-full left-0 bg-white shadow-md p-2 rounded-lg " style="top: 40px;">
          <div @click="changeFilter(item.value)" v-for="item in statusFilters" :key="item.index">
            <vs-checkbox class="mb-2 " :checked="filters.length === 0 && item.value === 'all' ? true : filters.includes(item.value)" :vs-value="item.value">
              <span class="capitalize">{{ $t(item.name) }}</span>
            </vs-checkbox>
          </div>
        </div>
      </div>
      <div class="relative md:w-48 w-full" :class="warehouseDropdownFlag ? 'filter-z-index' : ''">
        <div @click="warehouseDropdownFlag = !warehouseDropdownFlag" class="flex gap-4 cursor-pointer bg-white items-center border border-solid border-grey-light p-2 rounded-lg whitespace-nowrap overflow-hidden">
          <span class="material-icons-outlined text-lg">warehouse</span>
          <p class="truncate w-full capitalize font-medium text-sm">{{warehouseCode}}</p>
          <div class="text-right flex items-center">
            <feather-icon class="w-4 h-4" :icon="warehouseDropdownFlag ? 'ChevronUpIcon' : 'ChevronDownIcon'"></feather-icon>
          </div>
        </div>
        <div v-if="warehouseDropdownFlag" class="absolute w-full left-0 bg-white shadow-md p-2 rounded-lg " style="top: 40px;">
          <div @click="changeWarehouse(item.code)" v-for="item in warehouses" :key="item.index">
            <vs-checkbox class="mb-2 " :checked="warehouseCode === item.code" :vs-value="item.code">
              <span class="capitalize">{{ $t(item.name) }}</span>
            </vs-checkbox>
          </div>
        </div>
      </div>
      <export-button class="whitespace-nowrap md:w-auto w-full"></export-button>
    </div>

    <ShipBluTable
      :sst="true"
      multiple
      search
      v-model="selected"
      pagination
      :max-items="maximumItems"
      @search="handleSearch"
      @keyup.enter.native="handleSearch"
      :data="tableData"
      :tableLoader="tableLoader"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between"></div>
      <template slot="thead">
        <shipblu-th>{{$t('Name')}}</shipblu-th>
        <shipblu-th>{{$t('HR ID')}}</shipblu-th>
        <shipblu-th>{{$t('Start')}}</shipblu-th>
        <shipblu-th>{{$t('Completion')}}</shipblu-th>
        <shipblu-th>{{$t('Status')}}</shipblu-th>
        <shipblu-th>{{$t('Score')}}</shipblu-th>
        <shipblu-th>{{$t('Hub')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="text-left">
          <shipblu-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].hr_id">
            {{ data[indextr].hr_id }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].assigned_date">
            {{ data[indextr].assigned_date.split('T')[0] + ' ' + data[indextr].assigned_date.split('T')[1].split('+')[0] }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].completed_date">
            {{ data[indextr].completed_date ? data[indextr].completed_date.split('T')[0] + ' ' + data[indextr].completed_date.split('T')[1].split('+')[0] : '' }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].status">
            <span class="capitalize"> {{ $t(data[indextr].status.replace(/_/g, ' ')) }} </span>
          </shipblu-td>

          <shipblu-td :data="data[indextr].final_score">
            {{ data[indextr].final_score }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].hub">
            {{ data[indextr].primary_warehouse_name }}
          </shipblu-td>
        </shipblu-tr>
      </template>
    </ShipBluTable>

    <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />

    <p class="text-xl font-semibold mb-2 text-black" v-if="warehouseCode !== 'Warehouse'">{{ 'Unassigned Agents' }}</p>
    <ShipBluTable v-if="warehouseCode !== 'Warehouse'"
      :sst="true"
      multiple
      v-model="selected"
      pagination
      :max-items="maximumItems"
      :data="warehousetableData"
      :tableLoader="tableLoader"
    >
      <template slot="thead">
        <shipblu-th>{{$t('Name')}}</shipblu-th>
        <shipblu-th>{{$t('HR ID')}}</shipblu-th>
        <shipblu-th>{{$t('Email')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="text-left">
          <shipblu-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].hr_id">
            {{ data[indextr].hr_id }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].email">
            {{ data[indextr].email }}
          </shipblu-td>
        </shipblu-tr>
      </template>
    </ShipBluTable>
    <shipblu-pagination v-if="warehouseCode !== 'Warehouse'" :maximumItems="maximumItems" :noOptions="true" :totalRows="warehouseTotalRows" :currentPage="warehouseCurrentPage" @currentPage="warehouseCurrentPage = $event" />
  </div>
</template>

<script>
import TableFilter from '../../merchant/components/TableFilter.vue'
import ShipbluTr from '../../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../../layouts/components/ShipBluTd.vue'
import common  from '@/assets/utils/common'
import { sendRequest } from '../../../http/axios/requestHelper'
import ShipBluTable from '../../../layouts/components/ShipBluTable.vue'
import ShipbluPagination from '../../../layouts/components/ShipbluPagination.vue'
import ExportButton from '../../headOfFleet/components/ExportButton.vue'

export default {
  data () {
    return {
      tableData: [],
      warehousetableData: [],
      warehouseTotalRows: 0,
      filterDropdownFlag: false,
      warehouseDropdownFlag: false,
      statusFilters: [
        {
          name: 'ALL',
          value: 'all'
        },
        {
          name: 'ASSIGNED',
          value: 'assigned'
        },
        {
          name: 'IN PROGRESS',
          value: 'in_progress'
        },
        {
          name: 'COMPLETED',
          value: 'completed'
        },
        {
          name: 'OVERDUE',
          value: 'overdue'
        },
        {
          name: 'WAIVED',
          value: 'waived'
        }
      ],
      filters: [],
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      searchInProgress: false,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      warehouseCurrentPage: 1,
      tableLoader: false,
      searchedValue: ' ',
      searchVal: '',
      selected: [],
      offset: 0,
      warehouseOffset: 0,
      totalRows: 0,
      warehouses: [],
      warehousesDic: {},
      warehouse: {
        id: 'all',
        name: 'All',
        code: 'Warehouse'
      },
      warehouseCode: 'Warehouse',
      filterValue: ''
    }
  },
  methods: {
    formatWarehouses (warehouses) {
      this.warehouses = warehouses.filter(item => !item.is_virtual)
      this.warehouses.forEach(warehouse => {
        warehouse.name = `${warehouse.name}`
        this.warehousesDic[warehouse.id] = {
          name: warehouse.name,
          code: warehouse.code
        }
      })
      this.warehouses.unshift(
        {
          id: 'all',
          name: 'All',
          code: 'Warehouse'
        }
      )
    },
    changeFilter (type) {
      this.filterValue = type
      const filtersTemp = this.filters
      this.filters = []
      filtersTemp.forEach(item => {
        this.filters.push(item)
      })
      this.filters.includes(this.filterValue) ? this.filters.splice(this.filters.indexOf(this.filterValue), 1) : this.filters.push(this.filterValue)
      if (this.filterValue === 'all') {
        this.filters = []
      }
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters,
          programId: this.$route.query.programId,
          page: this.currentPage,
          warehouse: this.warehouseCode
        }
      }).catch(() => {})
      this.loadInsights()
    },
    handleSearch (search) {
      this.currentPage = 1
      this.searchVal = search.target ? search.target.value : search
      return common.manageSearch(search, this.loadInsightsSearch)
    },
    loadInsightsSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchVal) {
        return
      }
      this.loadInsights()
    },
    loadInsights () {
      this.tableLoader = true
      this.searchInProgress = true
      sendRequest(false, false, this, `api/v1/training/program-exam/?status=${this.filters}&search=${this.searchVal}&offset=${this.offset}&limit=${this.maximumItems}&training_program=${this.$route.query.programId}&warehouse_code=${this.warehouseCode === 'Warehouse' ? '' : this.warehouseCode}`, 'get', null, true,
        (response) => {
          this.tableData = response.data.results
          this.totalRows = response.data.count
          this.tableLoader = false
          this.searchedValue = this.searchVal
        }
      )
      this.searchInProgress = false
      if (this.warehouseCode !== 'Warehouse') {
        this.unattemptedUsers()
      }
    },
    unattemptedUsers () {
      this.tableLoader = true
      sendRequest(false, false, this, `api/v1/training/program-exams/unattempted-users/?training_program=${this.$route.query.programId}&status=${this.filters}&warehouse_code=${this.warehouseCode}&offset=${this.warehouseOffset}&limit=${this.maximumItems}`, 'get', null, true,
        (response) => {
          this.warehousetableData = response.data.results
          this.warehouseTotalRows = response.data.count
          this.tableLoader = false
        }
      )
    },
    changeWarehouse (code) {
      this.warehouseCode = code
      this.warehouse = this.warehousesDic[code]
      this.warehouseCurrentPage = 1
      this.warehouseDropdownFlag = false
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters,
          programId: this.$route.query.programId,
          page: this.currentPage,
          warehouse: this.warehouseCode
        }
      }).catch(() => {})
      this.loadInsights()
    }
  },
  watch: {
    '$route.query.filter' () {
      if (!this.$route.query.filter) {
        this.filters = []
        this.loadInsights()
      }
    },
    '$route.query.warehouse' () {
      if (!this.$route.query.filter) {
        this.filters = []
        this.loadInsights()
        this.unattemptedUsers()
      }
    },
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters,
          programId: this.$route.query.programId,
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadInsights()
    },
    warehouseCurrentPage () {
      this.warehouseOffset = (this.warehouseCurrentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters,
          programId: this.$route.query.programId,
          page: this.currentPage,
          warehouse: this.warehouseCode
        }
      }).catch(() => {})
      this.unattemptedUsers()
    }
  },
  components: {
    TableFilter,
    ShipBluTable,
    ShipbluTd,
    ShipbluTr,
    ShipbluTh,
    ShipbluPagination,
    ExportButton
  },
  created () {
    this.filters = this.$route.query.filter ? typeof (this.$route.query.filter) === 'string' ? Array(this.$route.query.filter) : this.$route.query.filter : []
    this.loadInsights()
    common.manageLoadWarehouses(this.formatWarehouses, this)
  }
}
</script>

<style lang="scss">
.shipment-modal {
  .vs-dialog {
    max-width: 800px !important;
    max-height: 90%;
  }
}
th {
  height: 50px ;
  vertical-align: center;
  font-size: 14px;
  font-weight: 400;
}
.filter-z-index {
  z-index: 9999;
  user-select: none;
}
table {
  min-width: 700px;
}
.con-pagination-table {
  display: none;
}
</style>